<template>
  <el-dialog
    title="扫码发货"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="扫码发货" name="first">
        <div style="margin-bottom: 8px;margin-left: 20px;display:flex;align-items:center;flex-wrap:wrap;">
          <span style="white-space:nowrap;font-size:12px;">选择仓库：</span>
          <el-select
            v-model="cangkucode"
            placeholder="请选择仓库（必选）"
            size="mini"
            style="width:200px"
            @change="onWarehouseChange">
            <el-option
              v-for="item in jxcstoreData"
              :key="item.cangkucode"
              :label="item.cangkuname"
              :value="item.cangkucode">
            </el-option>
          </el-select>
          <template v-if="parames.length>0">
            <span style="white-space:nowrap;font-size:12px;margin-left:20px;">账套：</span>
            <el-select
              v-model="hetongserial"
              filterable
              placeholder="请选择账套"
              size="mini"
              style="width:130px"
              @change="onHetongserialChange">
              <el-option
                v-for="item in parames"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
          <span style="white-space:nowrap;font-size:12px;margin-left:20px;">选择客户：</span>
          <el-select
            v-model="selectedCustomer"
            ref="customerSelect"
            filterable
            clearable
            placeholder="请选择客户（仅显示待配送订单）"
            size="mini"
            style="width:320px"
            @change="onCustomerChange"
            @keyup.enter.native="onCustomerEnter">
            <el-option
              v-for="item in customerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-checkbox v-model="showDetail" @change="onShowDetailChange" style="margin-left:20px;">显示订单明细</el-checkbox>
        </div>
        <div v-if="customerInfo"
             style="margin: 0 20px 8px 20px;font-size:14px;color:#606266;line-height:24px;">
          <span>客户名称：<b>{{customerInfo.customername}}</b></span>
          <span style="margin-left:15px;">客户编码：<b>{{customerInfo.customerserial}}</b></span>
          <span style="margin-left:15px;">联系人：<b>{{customerInfo.linkman}}</b></span>
          <span style="margin-left:15px;">电话：<b>{{customerInfo.linkmantel}}</b></span>
          <span style="margin-left:15px;">地址：<b>{{customerInfo.deliveryaddress}}</b></span>
        </div>
        <table style="height: 24px;margin-left: 20px">
          <tr>
            <td style="white-space: nowrap;">订单条码(回车扫码)：</td>
            <td style="width: 160px;">
              <el-input v-model="searchdata" size="mini" @keyup.enter.native="search" onfocus="this.select()" ref="searchInput"></el-input>
            </td>
            <td><b>{{filteredOrderCount}}</b>张订单，合计金额：<b>¥{{totalAmountSum}}</b>，运费合计：<b>¥{{totalFreightSum}}</b>，总计：<b style="color:red">¥{{grandTotalSum}}</b></td>
            <td style="width: 10px"></td>
            <td>
              <el-button type="danger" size="mini" @click="clearScanData">清空</el-button>
            </td>
          </tr>
        </table>
        <el-table
          :data="filteredTableData"
          ref="moviesTable"
          size="mini" :height="tableHeight(345)"
          stripe
          :span-method="objectSpanMethod"
          style="width: 100%;">
          <el-table-column label="订单号" prop="erpserial" width="130px">
            <template slot-scope="scope">
              {{scope.row.erpserial}}
            </template>
          </el-table-column>
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              {{scope.row.seedname}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasLens" label="眼别" width="55px" align="center">
            <template slot-scope="scope">
              {{scope.row.rl}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasLens" label="球镜" width="55px" align="right">
            <template slot-scope="scope">
              {{scope.row.sph}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasLens" label="柱镜" width="55px" align="right">
            <template slot-scope="scope">
              {{scope.row.cyl}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasLens" label="轴位" width="45px" align="center">
            <template slot-scope="scope">
              {{scope.row.axis}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasLens" label="ADD" width="50px" align="center">
            <template slot-scope="scope">
              {{scope.row.addv}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasFrame" label="型号" width="100px">
            <template slot-scope="scope">
              {{scope.row.model}}
            </template>
          </el-table-column>
          <el-table-column v-if="showDetail && hasFrame" label="色号" width="60px">
            <template slot-scope="scope">
              {{scope.row.color}}
            </template>
          </el-table-column>
          <el-table-column label="数量" width="60px">
            <template slot-scope="scope">
              {{scope.row.number}}
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="taxprice" width="80px" align="right">
            <template slot-scope="scope">
              {{scope.row.taxprice|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column label="运费" prop="expressfee" width="70px" align="right">
            <template slot-scope="scope">
              {{scope.row.detail.expressfee|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column label="金额" prop="totalmoney" width="80px" align="right">
            <template slot-scope="scope">
              {{scope.row.totalmoney|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" min-width="160px" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{getLiuYan(scope.row.detail.remark)}}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60px" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" icon="el-icon-delete" circle
                         @click="removeScanItem(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;padding: 8px 0;border-top: 1px solid #EBEEF5;">
          <table style="width: 100%">
            <tr>
              <td style="width: 80px;text-align: right;">物流公司：</td>
              <td style="width: 150px;">
                <el-select v-model="logisticsco" placeholder="请选择" style="width: 135px;" size="mini">
                  <el-option
                    v-for="item in parameterData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
              <td style="width: 80px;text-align: right;">快递单号：</td>
              <td>
                <el-input v-model="logisticsnum" size="mini" style="width: 160px;" placeholder="请填写快递单号"></el-input>
                <template v-if="logisticsnum">
                  <el-button circle type="info" @click="OrderPrint(false)" :loading="loadingexpress" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
                  <el-button circle type="warning" @click="OrderPrint(true)" :loading="loadingexpress" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
                  <el-button circle type="danger" @click="removeOrderService" :loading="loadingexpress" icon="el-icon-delete" title="撤销-快递单" size="mini"></el-button>
                </template>
                <el-button v-else circle type="success" @click="createOrderService" :loading="loadingexpress" icon="el-icon-edit" title="创建-快递单" size="mini"></el-button>
              </td>
            </tr>
            <tr>
              <td style="width: 80px;text-align: right;">补运费：</td>
              <td colspan="3">
                <el-input v-model="supplementaryFreight" size="mini" style="width: 100px;" placeholder="运费金额"></el-input>
                <el-checkbox v-model="noFreightThisTime" style="margin-left: 10px;" @change="onNoFreightChange">本次不补运费</el-checkbox>
              </td>
            </tr>
          </table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="发货日志" name="second">
        <el-table
          :data="tableDataHis"
          ref="fahuohisTable"
          size="mini"
          stripe
          style="width: 100%;">
          <el-table-column label="单号" width="130px">
            <template slot-scope="scope">
              {{scope.row.erpserial}}
            </template>
          </el-table-column>
          <el-table-column label="客户" >
            <template slot-scope="scope">
              {{scope.row.customername}}
            </template>
          </el-table-column>
          <el-table-column label="客户编码" width="100px">
            <template slot-scope="scope">
              {{scope.row.customerserial}}
            </template>
          </el-table-column>
          <el-table-column label="日期" width="150px">
            <template slot-scope="scope">
              {{scope.row.adddate}}
            </template>
          </el-table-column>
          <el-table-column label="出库人" width="100px">
            <template slot-scope="scope">
              {{scope.row.uname}}
            </template>
          </el-table-column>
          <el-table-column label="物流公司" width="100px">
            <template slot-scope="scope">
              {{scope.row.logisticsco}}
            </template>
          </el-table-column>
          <el-table-column label="快递单号" width="130px">
            <template slot-scope="scope">
              {{scope.row.logisticsnum}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click="printStoreform(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination ref="pagination1" @bindgrid="bindGridHis" :pagination="pagination"></Pagination>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="delivergoods" :loading="onloading" v-if="activeName=='first'" :disabled="filteredTableData.length==0">确认发货
      </el-button>
    </div>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <ScancodePrint ref="ScancodePrint1" @bindgrid="afterPrint"></ScancodePrint>
  </el-dialog>
</template>

<script>

  import {printing, batchErcifahuo, listCustomerByStatus400, listScanOrdersByCustomer, saveCstagreementData} from "../../../api/set/csagreement";
  import {listStoreform,batchScanSave} from "../../../api/set/jxcstoreform";
  import {getParameterDetail} from '@/api/set/parameter';
  import {sfOrderService, sfOrderPrint, loadPrintFile, sfOrderConfirm} from '@/api/order/express';
  import {getRemarkContent, getShipRemark} from '@/plugin/ordercommon';
  import HandlelogList from './HandlelogList'
  import ScancodePrint from './ScancodePrint';

  export default {
    name: "ScancodeDelivery",
    data() {
      return {
        activeName: 'first',
        //用来保存查询成功的订单
        scanerpserial: ';',
        jxcstoreData: [],
        tableData: [],
        tableDataHis: [],
        dialogSeeVisible: false,
        searchdata: '',
        onloading: false,
        loadingexpress: false,
        totalnumber: 0,
        // 物流信息
        logisticsco: '配送',
        logisticsnum: '',
        parameterData: [],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        userInfoModel: {},
        customerOptions: [],
        selectedCustomer: '',
        cangkucode: '',
        cangkuname: '',
        supplementaryFreight: '',
        noFreightThisTime: false,
        // 账套过滤（有账套时显示，允许选全部）
        hetongserial: '',
        parames: [],
        // 显示订单明细（localStorage记忆上次选择）
        showDetail: localStorage.getItem('scancodeDelivery_showDetail') == '1',
        // 已加载订单的原始数据（切换明细显示时重建列表用）
        rawOrders: [],
      }
    },
    methods: {
      initData(jxcstoreData) {
        // 过滤掉"全部仓库"等无效选项，仓库必须有值
        this.jxcstoreData = [];
        for (var i = 0; i < jxcstoreData.length; i++) {
          if (jxcstoreData[i].cangkucode) {
            this.jxcstoreData.push(jxcstoreData[i]);
          }
        }
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        this.clear();
        // 默认选中第一个仓库
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          this.cangkuname = this.jxcstoreData[0].cangkuname;
        }
        this.loadCustomerOptions();
        this.bindGridHis();
        this.dialogSeeVisible = true;
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      },
      close() {
        this.dialogSeeVisible = false;
      },
      loadCustomerOptions() {
        listCustomerByStatus400(this.cangkucode, this.hetongserial || '').then(response => {
          if (response.data.code == 0) {
            var list = response.data.obj;
            var options = [];
            for (var i = 0; i < list.length; i++) {
              var item = list[i];
              var value = item.CustomerSerial + '|' + (item.DeliveryAddress || '');
              var label = '[' + item.CustomerSerial + '] ' + item.CustomerName;
              if (item.DeliveryAddress) {
                label += ' - ' + item.DeliveryAddress;
              } else {
                label += ' - （无地址）';
              }
              options.push({
                value: value,
                label: label,
                customerserial: item.CustomerSerial,
                customername: item.CustomerName,
                deliveryaddress: item.DeliveryAddress || ''
              });
            }
            this.customerOptions = options;
          }
        }).catch(() => {});
      },
      onWarehouseChange(value) {
        // 更新仓库名称
        for (var i = 0; i < this.jxcstoreData.length; i++) {
          if (this.jxcstoreData[i].cangkucode == value) {
            this.cangkuname = this.jxcstoreData[i].cangkuname;
            break;
          }
        }
        // 清空已扫数据，重新加载客户选项
        this.clearScanData();
        this.loadCustomerOptions();
      },
      // 账套切换：清空已扫数据，按新账套重新加载客户选项
      onHetongserialChange() {
        this.clearScanData();
        this.loadCustomerOptions();
      },
      onCustomerChange(value) {
        if (!value) {
          return;
        }
        var parts = value.split('|');
        var customerserial = parts[0];
        var deliveryaddress = parts[1] || '';

        this.clearScanData();


        listScanOrdersByCustomer({
          customerserial: customerserial,
          deliveryaddress: deliveryaddress,
          cangkucode: this.cangkucode
        }).then(response => {
          if (response.data.code == 0) {
            var orders = response.data.obj;
            if (!orders || orders.length == 0) {
              this.$message({message: '该客户没有待配送订单', type: 'warning'});
              return;
            }
            for (var k = 0; k < orders.length; k++) {
              var obj = orders[k];
              // 检查是否重复
              if (this.scanerpserial.indexOf(';' + obj.detail.erpserial + ';') > -1) {
                continue;
              }
              this.scanerpserial += obj.detail.erpserial + ';';
              this.rawOrders.push(obj);
              var newRows = this.buildOrderRows(obj);
              for (var r = 0; r < newRows.length; r++) {
                this.tableData.push(newRows[r]);
              }
              this.totalnumber += 1;
            }
            // this.$message({
            //   message: '成功加载 ' + orders.length + ' 张订单！',
            //   type: 'success'
            // });
          }
        }).catch(() => {
          this.$message({message: '加载订单失败', type: 'error'});
        });
      },
      onCustomerEnter() {
        // 按回车选中根据输入文字过滤后的第一个客户
        var $select = this.$refs.customerSelect;
        if (!$select) return;
        var query = ($select.query || '').trim().toLowerCase();
        var matched = [];
        for (var i = 0; i < this.customerOptions.length; i++) {
          var opt = this.customerOptions[i];
          if (opt.label.toLowerCase().indexOf(query) > -1) {
            matched.push(opt);
          }
        }
        if (matched.length > 0) {
          this.selectedCustomer = matched[0].value;
          this.onCustomerChange(this.selectedCustomer);
        }
      },
      clear() {
        this.activeName = 'first'
        this.onloading = false
        this.loadingexpress = false
        this.tableData = [];
        this.rawOrders = [];
        this.totalnumber = 0
        this.scanerpserial = ';';
        this.logisticsco = this.parameterData.length > 0 ? this.parameterData[0].value : ''
        this.logisticsnum = ''
        this.searchdata = ''
        this.supplementaryFreight = ''
        this.noFreightThisTime = false
      },
      clearScanData() {
        this.tableData = [];
        this.rawOrders = [];
        this.totalnumber = 0
        this.scanerpserial = ';';
        this.searchdata = ''
        this.logisticsco = this.parameterData.length > 0 ? this.parameterData[0].value : ''
        this.logisticsnum = ''
        this.selectedCustomer = ''
        this.supplementaryFreight = ''
        this.noFreightThisTime = false
      },
      removeScanItem(row) {
        var index = this.tableData.indexOf(row);
        if (index < 0) {
          return;
        }
        this.tableData.splice(index, 1);
        // 该订单已无剩余商品行时，允许重新扫码
        var stillExists = false;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].erpserial == row.erpserial) {
            stillExists = true;
            break;
          }
        }
        if (!stillExists) {
          this.scanerpserial = this.scanerpserial.replace(';' + row.erpserial + ';', ';');
          // 同步移除原始订单数据
          for (var k = this.rawOrders.length - 1; k >= 0; k--) {
            if (this.rawOrders[k].detail.erpserial == row.erpserial) {
              this.rawOrders.splice(k, 1);
            }
          }
        }
      },
      onNoFreightChange(val) {
        if (val) {
          this.supplementaryFreight = '';
        }
      },
      // “显示订单明细”勾选（存localStorage，默认上次选择）
      onShowDetailChange(val) {
        localStorage.setItem('scancodeDelivery_showDetail', val ? '1' : '0');
        this.rebuildTableData();
      },
      // 根据已加载的原始订单重建列表（切换“显示订单明细”时调用）
      rebuildTableData() {
        var rows = [];
        for (var i = 0; i < this.rawOrders.length; i++) {
          rows = rows.concat(this.buildOrderRows(this.rawOrders[i]));
        }
        this.tableData = rows;
      },
      // 将一张订单构建为列表行（明细模式：按商品明细逐行；合并模式：按商品编码合并数量）
      buildOrderRows(obj) {
        var gds = obj.goodsDetail || [];
        var formdetail = [];
        var rows = [];
        var goods = [];
        for (var g = 0; g < gds.length; g++) {
          var gd = gds[g];
          formdetail.push({unitguid: gd.unitguid, fahuonumber: gd["数量"]});
          if (this.showDetail) {
            rows.push(this.buildDetailRow(obj, gd));
          } else {
            var exist = false;
            for (var j = 0; j < goods.length; j++) {
              if (goods[j].seedcode == gd.seedcode) {
                goods[j].number += gd["数量"];
                goods[j].totalmoney = (parseFloat(goods[j].totalmoney) || 0) + (parseFloat(gd["TotalMoneyTax"]) || 0);
                exist = true;
                break;
              }
            }
            if (!exist) {
              goods.push({number: gd["数量"], seedcode: gd.seedcode, seedname: gd["产品名称"], totalmoney: (parseFloat(gd["TotalMoneyTax"]) || 0)});
            }
          }
        }
        obj.detail.jxcformdetaillist = JSON.stringify(formdetail);
        for (var k = 0; k < goods.length; k++) {
          rows.push({
            erpserial: obj.detail.erpserial,
            customername: obj.detail.customername,
            customerserial: obj.detail.customerserial,
            deliveryaddress: obj.detail.deliveryaddress,
            seedname: goods[k].seedname,
            number: goods[k].number,
            totalmoney: goods[k].totalmoney,
            taxprice: (parseFloat(goods[k].totalmoney) || 0) / (parseFloat(goods[k].number) || 1),
            detail: obj.detail,
          });
        }
        // 排序已在后端listScanOrdersByCustomer中通过SortMap.sortMap完成（镜架优先、眼别R优先）
        return rows;
      },
      // 明细行（含镜片/镜架参数）
      buildDetailRow(obj, gd) {
        var rl = gd["R/L"] || '';
        if (rl.toUpperCase() == 'M') {//M为加工项，不是眼别，不显示
          rl = '';
        }
        return {
          erpserial: obj.detail.erpserial,
          customername: obj.detail.customername,
          customerserial: obj.detail.customerserial,
          deliveryaddress: obj.detail.deliveryaddress,
          seedname: gd["产品名称"],
          number: gd["数量"],
          totalmoney: gd["TotalMoneyTax"],//明细行金额（明细表TotalMoneyTax）
          taxprice: (parseFloat(gd["TotalMoneyTax"]) || 0) / (parseFloat(gd["数量"]) || 1),//含税单价
          detail: obj.detail,
          goodstype: gd["goodstype"] || '',
          rl: rl,
          sph: gd["球镜"] || '',
          cyl: gd["柱镜"] || '',
          axis: gd["轴位"] || '',
          addv: gd["ADD"] || '',
          model: gd["型号"] || '',
          color: gd["色号"] != null && gd["色号"] !== '' ? gd["色号"] : (gd["规格"] || ''),
        };
      },
      search() {
        this.searchdata = this.searchdata.trim();
        if (!this.searchdata) {
          return;
        }
        if (this.scanerpserial.indexOf(';' + this.searchdata + ';') > -1) {
          this.showError('不能重复扫码！');
          this.searchdata = '';
          return;
        }

        var sd = this.searchdata;
        this.searchdata = '';
        printing({erpserial: sd, forprint: "1"}).then(response => {
          if (response.data.code == 0) {
            var obj = response.data.obj
            if (obj.detail.status != 400) {
              this.showError(sd + '订单不是待配送状态！');
              return;
            }
            if (obj.detail.isreturnorder && obj.detail.isreturnorder == -1) {
              this.showError(sd + '订单已退货！');
              return;
            }

            // 校验订单仓库与所选仓库一致
            if (this.cangkucode && obj.detail.cangkucode && obj.detail.cangkucode != this.cangkucode) {
              this.showError(sd + '订单仓库与所选仓库不一致！订单仓库：' + (obj.detail.cangkuname || obj.detail.cangkucode));
              return;
            }

            // 校验所有扫码订单必须是同一个客户和同一个收货地址
            if (this.tableData.length > 0) {
              var first = this.tableData[0];
              if (first.customerserial != obj.detail.customerserial) {
                this.showError(sd + '订单客户与已扫订单不一致！要求客户：' + first.customername);
                return;
              }
              if (first.deliveryaddress != obj.detail.deliveryaddress) {
                this.showError(sd + '订单收货地址与已扫订单不一致！要求地址：' + first.deliveryaddress);
                return;
              }
            }

            this.scanerpserial += sd + ';';
            this.rawOrders.push(obj);
            var newRows = this.buildOrderRows(obj);
            for (var r = 0; r < newRows.length; r++) {
              this.tableData.push(newRows[r]);
            }
            this.totalnumber += 1;
            this.$message({
              message: sd + "加载成功！",
              type: 'success'
            })
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      validateSameCustomerAddress() {
        var filtered = this.filteredTableData;
        if (filtered.length == 0) {
          this.showError('请先扫码订单！');
          return false;
        }
        var first = filtered[0];
        for (var i = 1; i < filtered.length; i++) {
          if (filtered[i].customerserial != first.customerserial) {
            this.showError('订单' + filtered[i].erpserial + '的客户与第一单不一致！');
            return false;
          }
          if (filtered[i].deliveryaddress != first.deliveryaddress) {
            this.showError('订单' + filtered[i].erpserial + '的收货地址与第一单不一致！');
            return false;
          }
        }
        return true;
      },
      delivergoods() {
        // 只处理当前账套过滤出的订单
        var filtered = this.filteredTableData;
        if (filtered.length == 0) {
          if (this.tableData.length > 0) {
            this.showError('当前账套下没有可发货的订单！');
          } else {
            this.showError('请先扫码订单！');
          }
          return;
        }

        // 校验仓库已选择
        if (!this.cangkucode) {
          this.showError('请先选择仓库！');
          return;
        }

        // 校验同客户同地址
        if (!this.validateSameCustomerAddress()) {
          return;
        }

        // 如果选了快递公司且包含快递字样，必须填写单号
        if ((this.logisticsco.indexOf('快递') > -1 || this.logisticsco.indexOf('顺丰') > -1) && !this.logisticsnum) {
          this.showError('请填写快递单号！');
          return;
        }

        // 运费校验：当物流公司包含快递或顺丰时必填且金额大于0；运费合计已有值时不需要再补运费
        if (!this.noFreightThisTime) {
          if ((this.logisticsco.indexOf('快递') > -1 || this.logisticsco.indexOf('顺丰') > -1)) {
            if (parseFloat(this.totalFreightSum) <= 0) {
              this.showError('请填写补运费金额！');
              return;
            }
          }
        }

        this.onloading = true;

        // 收集过滤出的订单号（去重计数）
        var erpserials = '';
        var orderCount = 0;
        var seenSerial = {};
        for (var i = 0; i < filtered.length; i++) {
          erpserials += filtered[i].erpserial + ';';
          if (!seenSerial[filtered[i].erpserial]) {
            seenSerial[filtered[i].erpserial] = true;
            orderCount++;
          }
        }

        batchErcifahuo({
          erpserials: erpserials,
          logisticsco: this.logisticsco,
          logisticsnum: this.logisticsnum,
        }).then(response => {
          if (response.data.code == 0) {
            // 记录配送日志（仅过滤出的订单）
            var cusSerial = [];
            for (var i = 0; i < filtered.length; i++) {
              var exist = false;
              var detail = filtered[i].detail;
              for (var j in cusSerial) {
                if (cusSerial[j].customerserial == detail.customerserial && cusSerial[j].deliveryaddress == detail.deliveryaddress) {
                  exist = true;
                  if ((';' + cusSerial[j].erpserial + ';').indexOf(';' + detail.erpserial + ';') > -1) {
                    // 重复的不加载
                  } else {
                    cusSerial[j].erpserial = cusSerial[j].erpserial + ';' + detail.erpserial;
                  }
                }
              }
              if (!exist) {
                cusSerial.push({
                  customername: detail.customername,
                  customerserial: detail.customerserial,
                  deliveryaddress: detail.deliveryaddress,
                  erpserial: detail.erpserial
                })
              }
            }
            var firstDetail = filtered[0].detail;
            batchScanSave({
              cangkucode: firstDetail.cangkucode || '',
              cangkuname: firstDetail.cangkuname || '',
              logisticsco: this.logisticsco,
              logisticsnum: this.logisticsnum,
              remark: JSON.stringify(cusSerial)
            }).then(resOrder => {
              // 追加运费到第一个订单（追加，不覆盖）
              if (this.supplementaryFreight && parseFloat(this.supplementaryFreight) > 0) {
                var currentExpressfee = parseFloat(firstDetail.expressfee) || 0;
                var newExpressfee = currentExpressfee + parseFloat(this.supplementaryFreight);
                saveCstagreementData({
                  unitguid: firstDetail.unitguid,
                  expressfee: newExpressfee
                });
              }
              // 弹出打印发货汇总单（仅过滤出的订单）
              this.showPrintDeliverySummary(filtered);
              // 从列表中移除已发货订单，保留其他账套未发货订单
              var remaining = [];
              for (var i = 0; i < this.tableData.length; i++) {
                if (seenSerial[this.tableData[i].erpserial]) {
                  this.scanerpserial = this.scanerpserial.replace(';' + this.tableData[i].erpserial + ';', ';');
                } else {
                  remaining.push(this.tableData[i]);
                }
              }
              this.tableData = remaining;
              // 同步移除已发货订单的原始数据
              var remainingRaw = [];
              for (var i = 0; i < this.rawOrders.length; i++) {
                if (!seenSerial[this.rawOrders[i].detail.erpserial]) {
                  remainingRaw.push(this.rawOrders[i]);
                }
              }
              this.rawOrders = remainingRaw;
              // 重置运费、快递相关字段
              this.supplementaryFreight = '';
              this.noFreightThisTime = false;
              this.logisticsnum = '';
              this.$message({
                message: '成功发货' + orderCount + '单！',
                type: 'success'
              });
              // 刷新列表
              this.loadCustomerOptions();
              this.$emit('bindGrid');
              // 已无剩余订单时清空页面数据
              if (this.tableData.length == 0) {
                this.clearScanData();
              }
              this.onloading = false;
              this.bindGridHis();
            }).catch(() => {
              this.onloading = false;
            });
          } else {
            this.onloading = false;
            this.showError(response.data.msg);
          }
        }).catch((error) => {
          this.onloading = false;
          this.showError('发货失败');
        });
      },
      showPrintDeliverySummary(rows) {
        // 构建打印数据：所有已发货成功的订单集合
        var source = rows || this.tableData;
        var printRows = [];
        for (var i = 0; i < source.length; i++) {
          var row = source[i];
          printRows.push({
            erpserial: row.erpserial,
            customername: row.customername,
            customerserial: row.customerserial,
            deliveryaddress: row.deliveryaddress,
            detail: row.detail,
          });
        }
        if (printRows.length > 0) {
          this.$refs.ScancodePrint1.initDeliverySummary(printRows, this.logisticsco, this.logisticsnum, this.totalFreightSum);
        }
      },
      handlelog(erpserial) {
        // 日志已由后端 batchErcifahuo 接口统一记录
      },
      // ========== 快递接口（从CstagreementEdit复制） ==========
      createOrderService() {
        if (!this.filteredTableData.length) {
          this.showError('请先扫码订单！');
          return;
        }
        this.loadingexpress = true
        var firstDetail = this.filteredTableData[0].detail;
        sfOrderService({
          unitguid: firstDetail.unitguid,
          cangkucode: firstDetail.cangkucode,
          paymethod: this.logisticsco
        }).then(response => {
          if (response.data.code == 0) {
            this.logisticsnum = response.data.msg;
            if (response.data.express) {
              this.$message({
                message: '已创建过快递单！',
                type: 'error'
              })
              this.logisticsco = response.data.express
            }
            if (response.data.printurl)
              this.OrderPrintFile(response.data.printurl);
            else {
              this.loadingexpress = false
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loadingexpress = false
          }
        });
      },
      OrderPrint(needopen) {
        if (!this.logisticsnum) {
          this.showError('请先填写或创建快递单号');
          return;
        }
        this.loadingexpress = true
        sfOrderPrint({
          erpserial: this.filteredTableData.length > 0 ? this.filteredTableData[0].erpserial : '',
          expressno: this.logisticsnum,
          cangkucode: this.filteredTableData.length > 0 ? this.filteredTableData[0].detail.cangkucode : ''
        }).then(response => {
          if (response.data.code == 1) {
            this.$message({message: response.data.msg, type: 'error'});
            this.loadingexpress = false
            return;
          }
          this.OrderPrintFile(response.data.printurl, needopen);
        });
      },
      OrderPrintFile(printurl, needopen) {
        var thisFun = this;
        loadPrintFile(printurl, this.tableData.length > 0 ? this.tableData[0].detail.cangkucode : '', function () {
          thisFun.$message({
            message: '已发送到打印机！',
            type: 'success'
          })
          thisFun.loadingexpress = false;
        }, needopen);
        if (needopen) {
          thisFun.loadingexpress = false;
        }
      },
      removeOrderService() {
        if (!this.logisticsnum) {
          return;
        }
        this.loadingexpress = true
        this.$confirm("是否确定撤销快递单？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sfOrderConfirm({
            erpserial: this.filteredTableData.length > 0 ? this.filteredTableData[0].erpserial : '',
            expressno: this.logisticsnum
          }).then(response => {
            if (response.data.code == 0) {
              this.logisticsnum = '';
              this.$message({
                message: '已成功取消',
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.loadingexpress = false;
          })
        }).catch(() => {
          this.loadingexpress = false;
        });
      },
      // ========== 历史发货记录 ==========
      bindGridHis() {
        listStoreform({
          formtype: '80',
          status: 10,
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          showseedname: -1,
        }).then(response => {
          this.pagination.total = response.data.obj.total
          this.tableDataHis = response.data.obj.rows
        }).catch((error) => {
        });
      },
      handleloglook(erpserial) {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(erpserial);
      },
      printStoreform(row) {
        this.$refs.ScancodePrint1.initData(row);
      },
      afterPrint() {
        this.bindGridHis();
      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
        this.onloading = false
      },
      // 只显示发货备注（备注JSON中type='客户留言'的记录）
      getLiuYan(remark) {
        return getShipRemark(remark).replace(/<br\/>/g, "；");
      },
      // 订单号、运费、备注按订单号合并单元格（同一订单号只显示一次）；金额不合并，按商品行显示
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        var mergeProps = ['erpserial', 'expressfee', 'remark'];
        if (mergeProps.indexOf(column.property) > -1) {
          var rowspan = this.orderSpanArr[rowIndex];
          if (rowspan > 0) {
            return {rowspan: rowspan, colspan: 1};
          }
          return {rowspan: 0, colspan: 0};
        }
      },
    },
    computed: {
      // 当页明细中存在镜片商品（packagesize含X/Y节点）时显示镜片列
      hasLens() {
        if (!this.showDetail) {
          return false;
        }
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodstype == 'lens') {
            return true;
          }
        }
        return false;
      },
      // 当页明细中存在镜架商品（packagesize含M/C节点）时显示镜架列
      hasFrame() {
        if (!this.showDetail) {
          return false;
        }
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodstype == 'frame') {
            return true;
          }
        }
        return false;
      },
      // 按账套过滤后的订单行（hetongserial为空表示全部账套）
      filteredTableData() {
        if (!this.hetongserial) {
          return this.tableData;
        }
        var result = [];
        for (var i = 0; i < this.tableData.length; i++) {
          var detail = this.tableData[i].detail;
          if (detail && detail.currency == this.hetongserial) {
            result.push(this.tableData[i]);
          }
        }
        return result;
      },
      // 过滤后的订单张数（按订单号去重）
      filteredOrderCount() {
        var seen = {};
        var count = 0;
        for (var i = 0; i < this.filteredTableData.length; i++) {
          var erpserial = this.filteredTableData[i].erpserial;
          if (!seen[erpserial]) {
            seen[erpserial] = true;
            count++;
          }
        }
        return count;
      },
      // 选择客户（或扫码）后显示的客户信息：客户名称、编码、联系人、电话、地址
      customerInfo() {
        if (this.tableData.length > 0 && this.tableData[0].detail) {
          var d = this.tableData[0].detail;
          return {
            customername: d.customername,
            customerserial: d.customerserial,
            linkman: d.linkman,
            linkmantel: d.linkmantel,
            deliveryaddress: d.deliveryaddress
          };
        }
        return null;
      },
      // 计算每行按订单号合并的行数（相邻相同订单号的行合并）
      orderSpanArr() {
        var data = this.filteredTableData;
        var arr = [];
        for (var i = 0; i < data.length; i++) {
          if (i == 0 || data[i].erpserial != data[i - 1].erpserial) {
            var span = 1;
            for (var j = i + 1; j < data.length; j++) {
              if (data[j].erpserial == data[i].erpserial) {
                span++;
              } else {
                break;
              }
            }
            arr.push(span);
          } else {
            arr.push(0);
          }
        }
        return arr;
      },
      grandTotalSum() {
        return (parseFloat(this.totalAmountSum) + parseFloat(this.totalFreightSum)).toFixed(2);
      },
      totalFreightSum() {
        // 按订单号去重后汇总各订单已有的运费，加上本次补运费（只算过滤出的订单）
        var seen = {};
        var sum = 0;
        for (var i = 0; i < this.filteredTableData.length; i++) {
          var erpserial = this.filteredTableData[i].erpserial;
          if (!seen[erpserial]) {
            seen[erpserial] = true;
            var detail = this.filteredTableData[i].detail;
            if (detail && detail.expressfee) {
              sum += parseFloat(detail.expressfee) || 0;
            }
          }
        }
        if (this.supplementaryFreight) {
          sum += parseFloat(this.supplementaryFreight) || 0;
        }
        return sum.toFixed(2);
      },
      totalAmountSum() {
        // 按订单号去重后汇总金额（只算过滤出的订单）
        var seen = {};
        var sum = 0;
        for (var i = 0; i < this.filteredTableData.length; i++) {
          var erpserial = this.filteredTableData[i].erpserial;
          if (!seen[erpserial]) {
            seen[erpserial] = true;
            var detail = this.filteredTableData[i].detail;
            if (detail && detail.htje) {
              sum += parseFloat(detail.htje) || 0;
            }
          }
        }
        return sum.toFixed(2);
      }
    },
    mounted() {
      // 账套（处理模式同VoucherTJ页面）
      var param = JSON.parse(localStorage.getItem("hpapi_userInfoModel")).setofbooks;
      if (param) {
        this.parames = JSON.parse(param);
        this.parames.unshift({value: "", name: "全部账套"});
      }
      getParameterDetail({paraname: "快递公司"}).then(response => {
        for (let i = 0; i < JSON.parse(response.data.obj.paracontent).length; i++) {
          var obj = {
            name: '', value: ''
          }
          obj.name = JSON.parse(response.data.obj.paracontent)[i].name
          obj.value = JSON.parse(response.data.obj.paracontent)[i].name
          if (obj.name != '待邮寄') {
            this.parameterData.push(obj);
          }
        }
        this.logisticsco = this.parameterData.length > 0 ? this.parameterData[0].value : '';
      })
    },
    components: {
      HandlelogList,
      ScancodePrint
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ScancodeDelivery.vue